import { render, staticRenderFns } from "./VideoTrimming.vue?vue&type=template&id=c0b08d48&scoped=true&"
import script from "./VideoTrimming.vue?vue&type=script&lang=js&"
export * from "./VideoTrimming.vue?vue&type=script&lang=js&"
import style0 from "./VideoTrimming.vue?vue&type=style&index=0&id=c0b08d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b08d48",
  null
  
)

export default component.exports